(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farmtell-header"]) return;
  try {
    
document.addEventListener('click', function(event) {
  if (event.target.closest('.ft-mobile-menu a')) {
    document.querySelectorAll('.ft-mobile-menu[open]').forEach(function(menu) { menu.removeAttribute('open'); });
  }
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') document.querySelectorAll('.ft-mobile-menu[open]').forEach(function(menu) { menu.removeAttribute('open'); });
});

  } catch(e) { console.error(e); }
})();
})();
